import axios from 'axios';
import {createAction as createReduxAction} from 'redux-actions';
import {formQuery} from '@pluto/rest';
import {AppName, FormPayload, ListPayload} from './Types';

export const CLEAN = 'CLEAN';
export const FETCH = 'FETCH';
export const LOAD = 'LOAD';
export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const LOAD_DEVICES = 'LOAD-DEVICES';

const apiBaseUri = '/api/v1';

export const fetchListAction = createReduxAction(FETCH, async (offset: number): Promise<ListPayload<AppName>> => {
    const query = formQuery(`${apiBaseUri}/app-names`, offset);
    const {data} = await axios(query);
    return data;
});

export const loadAction = createReduxAction(LOAD, async (id: string): Promise<FormPayload<AppName>> => {
    const {data} = await axios(`${apiBaseUri}/app-names/${id}`);
    return data;
});

export const createAction = createReduxAction(CREATE, async (entity: Partial<AppName>): Promise<FormPayload<AppName>> => {
    const {data} = await axios.post(`${apiBaseUri}/app-names`, entity);
    return data;
});

export const updateAction = createReduxAction(UPDATE, async (id: string, entity: Partial<AppName>): Promise<FormPayload<AppName>> => {
    const {data} = await axios.put(`${apiBaseUri}/app-names/${id}`, entity);
    return data;
});

export const deleteAction = createReduxAction(DELETE, async (id: string) => {
    const {data} = await axios.delete(`${apiBaseUri}/app-names/${id}`);
    return data;
});

export const loadDevicesAction = createReduxAction(LOAD_DEVICES, async () => {
    const {data} = await axios(`${apiBaseUri}/devices?fields=_id,platform`);
    return data;
});

export const cleanAction = createReduxAction(CLEAN, () => {});
